import { isNullOrUndefined } from '~/util/validators/baseComponentsValidators'
import useUrl from './helpers/useUrl'
import { REQUEST_BY_RESOLUTION } from '~/constants/enum'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client, { $formFactor }) => {
  const root = useUrl('diia')
  return {
    /** @returns {Promise<AxiosResponse<GetVerificationProviderStatusResponse>>} */
    getStatusDiia() {
      const url = root('service_status')
      return client(url)
    },

    /** @returns {Promise<AxiosResponse<DiiaUserStatus>>} */
    getUserStatusDiia() {
      const url = root('user_status')
      return client.get(url)
    },

    /** @param {Object} GetDeeplinkDiiaDTO
      * @param {boolean} GetDeeplinkDiiaDTO.platform
      * @param {string} GetDeeplinkDiiaDTO.scope
      *
      * @returns{Promise<AxiosResponse<GetDeeplinkResponse>>} */
    getDeeplinkDiia({ platform, scope }) {
      if (isNullOrUndefined(platform)) platform = $formFactor() === REQUEST_BY_RESOLUTION.MOBILE

      const url = root('deeplink')
      const params = {
        'return_url': platform,
        scope,
      }
      return client.get(url, { params })
    },

    /** @returns {Promise<AxiosResponse<DiiaSharingScope>>} */
    getSharingScope() {
      const url = root('sharing-scope')
      return client.get(url)
    },
  }
}

/** @typedef {object} DiiaUserStatus
 * @property {null} type
 * @property {null} status
 * @property {string} next_step
 */
